<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{route.menuName}}</span>
      </div>
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" v-if="getIsView()" label="退货单号">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 退货单号:{{ form.no }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="创建时间" prop="createdTime" v-if="getIsView()">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else> 创建时间:{{   parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" label="发起人" v-if="getIsView()">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 发起人:{{ form.createdUserName }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="ownerDeptName" label="所属科室" v-if="getIsView()">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 所属科室:{{ form.ownerDeptName }}</span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="acceptInStockNo" label="采购入库" v-if="getIsView()">
                <el-select v-model="form.acceptInStockNo" :disabled="!editMode" placeholder="请选择采购入库单" filterable :filter-method="getAcceptInStockList" @change="acceptInStockChange" style="width:100%">
                  <el-option v-for="item in acceptInStockList" :key="item.id" :label="item.no" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else> 采购入库:{{ form.acceptInStockNo }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="date" label="退库日期" v-if="getIsView()">
                <el-date-picker :disabled="!editMode" v-model="form.date" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="采购日期" style="width:100%"></el-date-picker>
              </el-form-item>
              <span class="viewText" v-else> 退库日期:{{   parseTime(new Date(form.date), "{y}-{m}-{d}") }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="warehouseName" label="退库仓库" v-if="getIsView()">
                <el-select v-model="form.warehouseName" :disabled="!editMode" placeholder="请选择" filterable :filter-method="getOneLevelWarehousesBySessionWarehouseId" @change="warehouseChange" style="width:100%">
                  <el-option v-for="item in STATIC_OneLevelWarehouses" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else> 退库仓库:{{ form.warehouseName }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="category" label="退货类型" v-if="getIsView()">
                <el-radio-group disabled v-model="form.category">
                  <el-radio v-for="item in StockCategoryOptions" :key="item.id" :label="item.id">{{item.name}}退货</el-radio>
                </el-radio-group>
              </el-form-item>
              <span class="viewText" v-else> 退货类型:{{  StockCategoryOptions.find(item => item.id === form.category)?.name  }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="supplierName" label="供应商" v-if="getIsView()">
                <el-select v-model="form.supplierName" :disabled="!editMode" placeholder="请选择" filterable :filter-method="(value)=> getSuppliers(value, 1)" @change="supplierChange" style="width:100%">
                  <el-option v-for="item in STATIC_Suppliers" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else> 供应商:{{ form.supplierName }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalNumber" label="总数量" v-if="getIsView()">
                <el-input disabled placeholder="请输入总数量" v-model="form.totalNumber" type="number"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 总数量:{{ form.totalNumber }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalAmount" label="总金额" v-if="getIsView()">
                <el-input type="number" disabled placeholder="请输入总金额" v-model="form.totalAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 总金额:{{ form.totalAmount }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="退货理由" prop="remark" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="退货理由" v-model="form.remark"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 退货理由:{{ form.remark }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="结算金额" prop="balanceAmount" v-if="getIsView()">
                <el-input disabled v-model="form.balanceAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 结算金额:{{ form.balanceAmount }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="结算状态" prop="balanceStatus" v-if="getIsView()">
                <el-input disabled v-model="form.balanceStatusName"></el-input>
                <!-- <el-radio-group style="flex: 1; line-height: 60px" disabled v-model="form.balanceStatus">
                  <el-radio :label="0">已结算</el-radio>
                  <el-radio :label="1">部分结算</el-radio>
                  <el-radio :label="2">未结算</el-radio>
                </el-radio-group> -->
              </el-form-item>
              <span class="viewText" v-else> 结算状态:{{ form.balanceStatusName }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="开票金额" prop="billAmount" v-if="getIsView()">
                <el-input disabled v-model="form.billAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 开票金额:{{ form.billAmount }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="开票号码" prop="billNo" v-if="getIsView()">
                <el-input disabled v-model="form.billNo"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 开票号码:{{ form.billNo }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''"> 
              <el-form-item prop="patientNo" label="住院号" v-if="getIsView()">
                <el-input disabled v-model="form.patientNo"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 住院号:{{ form.patientNo }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="patientName" label="患者姓名" v-if="getIsView()">
                <el-input disabled v-model="form.patientName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 患者姓名:{{ form.patientName }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="doctorName" label="医生姓名" v-if="getIsView()">
                <el-input disabled v-model="form.doctorName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 医生姓名:{{ form.doctorName }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="doctorNo" label="医生工号" v-if="getIsView()">
                <el-input disabled v-model="form.doctorNo"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 医生工号:{{ form.doctorNo }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6" v-if="form.category == 1" :class="!getIsView()?'viewCol':''">
              <el-form-item label="备货使用科室" prop="stockUpUseDept" v-if="getIsView()">
                <el-input disabled v-model="form.stockUpUseDeptName"></el-input>
                <!-- <el-select :disabled="!editMode" v-model="form.stockUpUseDept" style="width: 90%" filterable placeholder="请选择备货科室" :filter-method="getDepts" @change="deptChange">
                                <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select> -->
              </el-form-item>
              <span class="viewText" v-else> 备货使用科室:{{ form.stockUpUseDeptName }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="是否超量" prop="isChaoLiang" v-if="getIsView()">
                <!-- <el-input disabled v-model="form.isChaoLiang"></el-input> -->
                <el-select v-model="form.isChaoLiang" disabled placeholder="请选择是否超量" style="width:100%">
                  <el-option v-for="item in IsGouCaiOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else> 是否超量:{{ IsGouCaiOptions.find(item => item.id == form.isChaoLiang)?.name }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="system_setting.IsUsePDA&&getIsView()" label="下架状态" prop="shelfState" >
                <el-select v-model="form.unShelfState" disabled placeholder="请选择下架状态" style="width:100%">
                  <el-option v-for="item in UnShelfStatusOptions " :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-if="system_setting.IsUsePDA&&!getIsView()"> 下架状态:{{ UnShelfStatusOptions.find(item=>item.id==form.unShelfState)?.name }}</span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">退货明细</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
            <el-button class="btn default" size="small" v-preventReClick @click="openScanner">点击开始扫描</el-button>
            <el-input :disabled="!editMode" placeholder="扫描标签码添加明细" v-model="tagCode" ref="tagCodeInput" style="width:300px;margin-left:30px" @change="tagCodeChange"></el-input>
            <el-button  class="btn primary" type="primary" style="margin-left:20px"
            @click="showTransfer">自定义设置</el-button>
          </div>
          <div v-else style="margin: 20px 0 12px 10px">
            <el-button class="btn primary" type="primary" style="margin-right: 10px"
            @click="showTransfer">自定义设置</el-button>
          </div>
          <div v-if="tableHaeder.length>0">
            <CustomTable  ref="customTable" :tableData="form.details" @handleSelectionChange="handleChildSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
            :tableHeight="tableHeight"  :tableCode="route.name" :cellDblclick="cellDblclick"> 
              <template slot="before">
                <el-table-column type="index" width="50" fixed> </el-table-column>
                <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
              </template>
              <template slot="after">
                <el-table-column fixed="right" prop="operation" label="标签详情" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" v-if="scope.row.hasTagCode==1" v-preventReClick class="color-blue" @click="tagCodeView(scope.row)">查看</el-button>
                  </template>
                </el-table-column>
              </template>
            </CustomTable>
          </div>
          <div v-else>
            <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
              <el-table-column type="index" width="50" fixed> </el-table-column>
              <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
  
              <el-table-column :show-overflow-tooltip="true" prop="productName" label="产品" width="180" fixed></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="specName" label="产品规格" width="120" fixed></el-table-column>
  
              <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
              <!-- <el-table-column prop="brand" label="品牌" width="120"></el-table-column> -->
              <el-table-column :show-overflow-tooltip="true" prop="manufacturerName" label="生产厂家" width="180"></el-table-column>
              <el-table-column prop="number" label="退货数量" width="90">
                <template slot-scope="scope">
                  {{ scope.row.number?scope.row.number:'-' }}
                </template>
              </el-table-column>
              <el-table-column prop="packSpec" label="包装规格" width="100">
                <template slot-scope="scope">
                  {{ scope.row.packSpec?scope.row.packSpec:'-' }}
                </template>
              </el-table-column>
              <el-table-column prop="minUnit" label="最小单位" width="80">
                <template slot-scope="scope">
                  {{ scope.row.minUnit?scope.row.minUnit:'-' }}
                </template>
              </el-table-column>
              <el-table-column prop="unit" label="包装单位" width="80">
                <template slot-scope="scope">
                  {{ scope.row.unit?scope.row.unit:'-' }}
                </template>
              </el-table-column>
              <el-table-column prop="price" label="采购价" width="80">
                <template slot-scope="scope">
                  {{ scope.row.price?scope.row.price:'-' }}
                </template>
              </el-table-column>
              <el-table-column prop="amount" label="小计" width="90">
                <template slot-scope="scope">
                  {{ scope.row.amount?scope.row.amount:'-' }}
                </template>
              </el-table-column>
              <el-table-column  label="货位" width="180">
                <template slot-scope="scope">
                  <el-select :disabled="!editMode" placeholder="请选择货位" v-model="scope.row.locationName" filterable @change="locationChange(scope.row)">
                    <el-option v-for=" item in STATIC_Locations" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="batch" label="批次号" width="120">
                <template slot-scope="scope">
                  {{ scope.row.batch?scope.row.batch:'-' }}
                </template>
              </el-table-column>
              <el-table-column prop="validityDate" label="有效期" width="120">
                <template slot-scope="scope">
                  {{ scope.row.validityDate? parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}") : "-"}}
                </template>
              </el-table-column>
              <el-table-column prop="longTime" label="长期" width="60">
                <template slot-scope="scope">
                  {{ scope.row.longTime == 1 ? "是" : "否"}}
                </template>
              </el-table-column>
              <el-table-column prop="manufactureDate" label="生产日期" width="120">
                <template slot-scope="scope">
                  {{scope.row.manufactureDate ? parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}") : "-"}}
                </template>
              </el-table-column>
              <!-- <el-table-column prop="disinfectDate" label="灭菌日期" width="150">
                <template slot-scope="scope">
                  {{ scope.row.disinfectDate ? parseTime(new Date(scope.row.disinfectDate), "{y}-{m}-{d}") : "" }}
                </template>
              </el-table-column> -->
              <el-table-column prop="serialNo" label="序列号" width="120">
                <template slot-scope="scope">
                  {{ scope.row.serialNo?scope.row.serialNo:'-' }}
                </template>
              </el-table-column>
              <!-- <el-table-column :show-overflow-tooltip="true" prop="disinfectBatch" label="灭菌批号" width="120">
              </el-table-column> -->
              <el-table-column show-overflow-tooltip prop="mainNo" label="主条码" width="180">
                <template slot-scope="scope">
                  {{ scope.row.mainNo?scope.row.mainNo:'-' }}
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="traceNo" label="追溯码" width="180">
                <template slot-scope="scope">
                  {{ scope.row.traceNo?scope.row.traceNo:'-' }}
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="productRegistCertName" label="产品注册证" width="180">
                <template slot-scope="scope">
                  {{ scope.row.productRegistCertName?scope.row.productRegistCertName:'-' }}
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="productRegistCertNo" label="注册证号" width="180">
                <template slot-scope="scope">
                  {{ scope.row.productRegistCertNo?scope.row.productRegistCertNo:'-' }}
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="newProductId" label="产品ID" width="150">
                <template slot-scope="scope">
                  {{ scope.row.newProductId?scope.row.newProductId:'-' }}
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="productCode" label="商品代码" width="150">
                <template slot-scope="scope">
                  {{ scope.row.productCode?scope.row.productCode:'-' }}
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="medicalInsuranceCategoryNo" label="医保代码" width="150">
                <template slot-scope="scope">
                  {{ scope.row.medicalInsuranceCategoryNo?scope.row.medicalInsuranceCategoryNo:'-' }}
                </template>
              </el-table-column>
               <el-table-column v-if="system_setting.isShowSecondSupplier" prop="secondSupplierName" show-overflow-tooltip
            width="140" label="二级供应商">
            <template slot-scope="scope">
              {{ scope.row.secondSupplierName?scope.row.secondSupplierName:'-' }}
            </template>
          </el-table-column>
              <el-table-column show-overflow-tooltip prop="remark" label="备注" width="200">
                <template slot-scope="scope">
                  {{ scope.row.remark?scope.row.remark:'-' }}
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="onlineNo" label="挂网号" width="120">
                <template slot-scope="scope">
                  {{ scope.row.onlineNo?scope.row.onlineNo:'-' }}
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="newOnlineNo" label="新挂网号" width="150">
                <template slot-scope="scope">
                  {{ scope.row.newOnlineNo?scope.row.newOnlineNo:'-' }}
                </template>
              </el-table-column>
              <el-table-column fixed="right" prop="operation" label="标签详情" width="100">
                <template slot-scope="scope">
                  <el-button type="text" v-if="scope.row.hasTagCode==1" v-preventReClick class="color-blue" @click="tagCodeView(scope.row)">查看</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

         
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

      <el-dialog title="产品信息" :visible.sync="openSubformModal" :center="true" width="1100px" :before-close="cancelChildDialog" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="childForm" :model="childForm" :rules="childFormRules">
          <el-row v-if="isScan">
            <el-col :span="24">
              <el-form-item label="扫码框">
                <el-input placeholder="请扫码" ref="no" @change="mainNoChange" v-model="childForm.no" @focus="scanInputFocus" @blur="scanInputBlur"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="mainNo" label="主条码">
                <el-input disabled placeholder="请输入主条码" v-model="childForm.mainNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="traceNo" label="追溯码">
                <el-input disabled placeholder="请输入追溯码" v-model="childForm.traceNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="supplierProductNo" label="供应商产品编码">
                <el-input disabled v-model="childForm.supplierProductNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productName" label="产品名称">
                <el-input v-if="isScan" disabled v-model="childForm.productName"></el-input>
                <SelectTable v-if="!isScan" :disabled="!editMode" :columns="stockColumns" :innerName="childForm.productName" :dataList="STATIC_Stocks" @filterMethod="getProductList" @change="productChange" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="specName" label="规格型号">
                <el-input disabled v-model="childForm.specName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productRegistCertId" label="产品注册证">
                <el-input disabled v-model="childForm.productRegistCertName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="productRegistCertNo" label="注册证号">
                <el-input disabled v-model="childForm.productRegistCertNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="manufacturerName" label="生产厂家">
                <el-input disabled v-model="childForm.manufacturerName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="onlineNo" label="挂网号">
                <el-input disabled v-model="childForm.onlineNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="brand" label="品牌">
                <el-input disabled v-model="childForm.brand"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="minUnit" label="最小单位">
                <el-input disabled v-model="childForm.minUnit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="unit" label="包装单位">
                <el-input disabled v-model="childForm.unit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="packSpec" label="包装规格">
                <el-input disabled v-model="childForm.packSpec"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item prop="disinfectDate" label="灭菌日期">
                <el-date-picker :disabled="!editMode" v-model="childForm.disinfectDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="disinfectBatch" label="灭菌批号">
                <el-input :disabled="!editMode" placeholder="请输入灭菌批号" v-model="childForm.disinfectBatch"></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="manufactureDate" label="生产日期">
                <el-date-picker disabled v-model="childForm.manufactureDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择生产日期" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="validityDate" label="有效期">
                <el-date-picker disabled v-model="childForm.validityDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择有效期" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item prop="longTime" label="长期">
                <el-switch v-model="childForm.longTime" disabled active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="batch" label="批次号">
                <el-input disabled placeholder="请输入批次号" v-model="childForm.batch"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="serialNo" label="序列号">
                <el-input disabled placeholder="请输入序列号" v-model="childForm.serialNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="locationName" label="货位">
                <el-select disabled placeholder="请选择货位" v-model="childForm.locationName" filterable @change="childLocationChange" style="width:100%">
                  <el-option v-for="item in STATIC_Locations" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="number" label="数量">
                <el-input-number :disabled="!editMode" v-model="childForm.number" :min="0" :precision="2" ref="number" :controls="false" placeholder="请填写数量" @change="autoAmount" style="width: 100%"></el-input-number>
                <!-- <el-input :disabled="!editMode" placeholder="请输入数量" type="number" min="0" ref="number" v-model="childForm.number" @input="autoAmount"></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="price" label="退货价">
                <el-input :disabled="!editMode" @input="autoAmount" v-model="childForm.price"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="amount" label="金额">
                <el-input disabled v-model="childForm.amount"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="newProductId" label="产品ID">
                <el-input disabled v-model="childForm.newProductId"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productCode" label="商品代码">
                <el-input disabled v-model="childForm.productCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="newOnlineNo" label="新挂网号">
                <el-input disabled v-model="childForm.newOnlineNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="medicalInsuranceCategoryNo" label="医保代码">
                <el-input disabled v-model="childForm.medicalInsuranceCategoryNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="remark" label="备注">
                <el-input :disabled="!editMode" v-model="childForm.remark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="">
          <el-button v-if="!isScan && editMode" class="btn primary" type="primary" size="small" v-preventReClick @click="continueAdd">新增下一条</el-button>
          <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode &&system_setting.IsUsePDA" class="btn default"  v-preventReClick @click="createPdaTask">创建PDA下架任务</my-button>

      <my-button v-if="editMode && form.status!=0" class="btn primary" type="primary" v-preventReClick @click="proTemSave">暂 存</my-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
    <LabelDetailsDialog v-if="labelDetailsVisible" :open="labelDetailsVisible" :data="labelDetailsData" 
    @tagCodeDelete="tagCodeDelete"
    @close="closeLabelDetailsDialog"/>
    <PackageLabelDialog v-if="packageLabelVisible" :open="packageLabelVisible" :data="packageLabeData"
    @viewDetails="viewDetails"
     @tagCodeDelete="tagCodeDelete"
     @close="closePackageLabelDialog"/>
     <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import ScanMixin from '@/mixin/outStockScan-mixin'
import tagCodeMixin from "@/mixin/tagCode-mixin";
import {
  GetAcceptOutStockById,
  SaveAcceptOutStock,
  RejectAcceptOutStock,
  PushPurchaseOutStock,
  ValidatePMOutStockDetail,
  GetAcceptInStocks,
  GetWarehouseById,
  GetAcceptInStockById,
  AcceptOutStockChaoLiangValidate,
  SaveAcceptOutStockTemp
} from "@/api";
import {
  StockCategoryOptions,
  IsGouCaiOptions,
  UnShelfStatusOptions
} from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import LabelDetailsDialog from "@/components/labelDetails-dialog";
import PackageLabelDialog from "@/components/packageLabel-dialog";
export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin, ScanMixin,tagCodeMixin],
  components: {
    SelectTable,
    ApproveInfo,
    LabelDetailsDialog,
    PackageLabelDialog,
  },
  data () {
    return {
      form: {},
      GetDataAction: GetAcceptOutStockById,
      SaveDataAction: SaveAcceptOutStock,
      reject: RejectAcceptOutStock,
      UnShelfStatusOptions,
      StockCategoryOptions: StockCategoryOptions,
      IsGouCaiOptions: IsGouCaiOptions,
      SaveTempAction: SaveAcceptOutStockTemp,

      rules: {
        warehouseName: [{
          required: true,
          message: "请选择退库仓库",
          trigger: "blur"
        },],
        date: [{
          required: true,
          message: "请选择退库日期",
          trigger: "blur"
        }],
        category: [{
          required: true,
          message: "请选择退库类型",
          trigger: "blur"
        },],
        supplierName: [{
          required: true,
          message: "请选择供应商",
          trigger: "blur"
        },],
        remark: [{
          required: true,
          message: "请选择退货理由",
          trigger: "blur"
        },],
        acceptInStockNo: [{
          required: true,
          message: "请选择采购入库单号",
          trigger: "blur"
        },
       ,],
      },
      childFormRules: {
        // manufactureDate: [
        //   { required: true, message: "请选择生产日期", trigger: "blur" },
        // ],
        // validityDate: [
        //   { required: true, message: "请选择有效期", trigger: "blur" },
        // ],
        // batch: [{ required: true, message: "请输入批次号", trigger: "blur" }],
        // productRegistCertId: [{ required: true, message: "请选择产品注册证", trigger: "blur" }],
        // packSpec: [{ required: true, message: "请输入包装规格", trigger: "blur" }],
        productName: [{
          required: true,
          message: "请选择产品",
          trigger: "blur"
        }],
        price: [{
          required: true,
          message: "请输入退货价",
          trigger: "blur"
        },],
        number: [{
          required: true,
          message: "数量不能为空",
          trigger: "blur"
        },
        {
          type: "number",
          min: 0.01,
          message: "数量必须大于0",
          trigger: "blur",
        },
        ]
      },
      editMode: false,
      showWorkFlowInfo: false,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},

      isScan: false,

      acceptInStockList: [],
      acceptInStockDetails:[]
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }
    if (query.acceptInStockId) {
      this.acceptInStockChange(query.acceptInStockId).then(res=>{
        this.form.details = res.details.map(item=>{
             item.number = item.number - item.refundNumber
              // item.number - item.refundNumber
             item.amount = item.number * item.price
                  return item
                })
                this.autoTotalAmount()
      })
    }

    this.getAcceptInStockList('')
    this.getSuppliers("", 1);
    this.getOneLevelWarehousesBySessionWarehouseId("");
    //  this.getDepts("");
    this.getTabelList("");
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({
        id
      }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.getLocations(this.form.warehouseId);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.initWorkFlowProperty(this.form);

      });
    },
    // 保存
    submit () {
      this.$store.dispatch('SetLoading',true)
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          this.$store.dispatch('SetLoading',false)
          return false;
        }
        if(this.system_setting.IsUsePDA&&(this.form.unShelfState==0||this.form.unShelfState==1||this.form.unShelfState==2)){
          this.$my_message("该单据DAP提交", 'warning');
           this.$store.dispatch('SetLoading',false)
          return
        }
        
        AcceptOutStockChaoLiangValidate(this.form)
          .then(res => {
            if (res.returnData) {
              const h = this.$createElement
              let content = []
              if (res.returnData.length > 0) {
                // content = [h('p', '以下所选医院采购订单存在价格异常：')]
                for (var i = 0; i < this.form.details.length; i++) {
                  let d = res.returnData.find(e => e.supplierProductId == this.form.details[i].supplierProductId);
                  if (d) {
                    content.push(h('p', `第${i + 1}行【${this.form.details[i].productName}】产品在当前集采执行期内存在超量入库，请先做超量部分的退货。`))
                  }
                }
              }

              this.$alert('提示', {
                title: '提示',
                type: 'warning',
                confirmButtonText: '我知道了',
                message: h('div', content)
              })
              this.$store.dispatch('SetLoading',false)
              return;
            }
            else {
              this.$store.dispatch('SetLoading',false)
              return this.SaveDataAction(this.form).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });
            }
          })
          .then((res) => {
            // 是否需要上传数据到价格监管平台
            var isNeedPushToPriceMonitor = res.returnData.isNeedPushToPriceMonitor
            if (isNeedPushToPriceMonitor && res.returnData.status == 2 && this.system_setting.isAutoSubmitOrderToPriceMonitor) {
              let id = res.returnData.id
              // 上传订单到价格监管平台，流程审批通过的数据直接上传
              ValidatePMOutStockDetail({
                id: id
              })
                .then(res => {
                  if (res.returnData) {
                    var exceptionList = res.returnData.exceptionList
                    var notFinishCompareList = res.returnData.notFinishCompareList
                    // 提示
                    if (exceptionList.length > 0 || notFinishCompareList.length > 0) {
                      const h = this.$createElement
                      let content = [h('p', '上传订单到价格监管平台时，检测到此采购退货存在以下异常：')]
                      if (exceptionList.length > 0) {
                        // content = [h('p', '以下所选医院采购订单存在价格异常：')]
                        exceptionList.forEach(item => {
                          content.push(h('p', {
                            style: 'color:red'
                          }, `价格异常`))
                        });
                      }
                      if (notFinishCompareList.length > 0) {
                        // content = [h('p', '以下所选医院采购订单存在未对照的目录：')]
                        notFinishCompareList.forEach(item => {
                          content.push(h('p', {
                            style: 'color:red'
                          }, `存在未对照的目录`))
                        });
                      }

                      content.push(h('p', '确定要继续上传吗？'))

                      this.$confirm('提示', {
                        title: '提示',
                        type: 'warning',
                        message: h('div', content)
                      })
                        .then(() => {
                          // 上传订单  
                          this.pushOrder(id)
                        })
                        .catch(() => {
                          this.$my_message(`执行成功`, "success");
                          sessionStorage.setItem("editMode", 0);
                          // this.$router.push({ path: this.getMainPath(this.$route.path) });
                          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
                        })
                    } else {
                      this.pushOrder(id)
                    }
                  } else {
                    // 上传订单
                    this.pushOrder(id)
                  }
                })
            } else {
              this.$my_message(`执行成功`, "success");
              sessionStorage.setItem("editMode", 0);
              // this.$router.push({ path: this.getMainPath(this.$route.path) });
              this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
            }
          });
      });
    },
    pushOrder (id) {
      PushPurchaseOutStock({
        id: id
      })
        .then(res => {
          var notNeedPushCount = res.returnData.notNeedPushCount
          var successCount = res.returnData.successCount
          var failedCount = res.returnData.failedCount
          var failedMessageDic = res.returnData.failedMessageDic
          var message = `上传成功${successCount}条;\n`
          message += `上传失败${failedCount}条;\n`
          message += `${notNeedPushCount}条不需要上传;\n`
          if (failedMessageDic) {
            message += `错误详情：`
            for (let key in failedMessageDic) {
              message += `明细编码：${key},异常信息:${failedMessageDic[key]};`
            }
          }

          this.$my_message(message, 'success');
          // sessionStorage.setItem("editMode", 0);
          // // this.$router.push({ path: this.getMainPath(this.$route.path) });
          // this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        })
        .finally(() => {
          sessionStorage.setItem("editMode", 0);
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        })
    },
    resetForm () {
      this.form = {
        acceptInStockNo: '',
        acceptInStockId: '',
        supplierId: "",
        supplierName: '',
        deliveryTime: new Date(),
        // warehouseCategory: "1",
        // "warehouseId": this.userInfo.defaultWarehouseId,
        // warehouseName: this.userInfo.defaultWarehouseName,
        // warehouseManagerId: this.userInfo.defaultWarehouseManagerId,
        // warehouseManagerName: this.userInfo.defaultWarehouseManagerName,
        totalNumber: 0,
        totalAmount: 0,
        orderNo: "",
        category: 0,
        remark: "",
        "balanceStatus": 2,
        warehouseName: '',
        isChaoLiang: 0,
        details: [],
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        orgCode :sessionStorage.getItem('orgId'),
      };
      this.setDefaultWarehouseBySessionWarehouseId(1)
      // let warehouseId = this.mySessionStorage.getWarehouseId()
      // GetWarehouseById({ id: warehouseId })
      //   .then(res => {
      //     let warehouse = res.returnData
      //     if (warehouse && warehouse.category == 1) {
      //       this.form.warehouseCategory = "1"
      //       this.form.warehouseId = warehouse.id
      //       this.form.warehouseName = warehouse.name
      //       this.form.warehouseManagerId = warehouse.managerId
      //       this.form.warehouseManagerName = warehouse.managerName
      //     }
      //   })
      // if (this.userInfo.defaultWarehouseCategory == 1) {
      //   this.form.warehouseCategory = "1"
      //   this.form.warehouseId = this.userInfo.defaultWarehouseId
      //   this.form.warehouseName = this.userInfo.defaultWarehouseName
      //   this.form.warehouseManagerId = this.userInfo.defaultWarehouseManagerId
      //   this.form.warehouseManagerName = this.userInfo.defaultWarehouseManagerName
      // }
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm () {
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.getProductList('')
      this.isScan = false;
    },
    handleDeleteChildForm () {
      if(this.checkIsRfid(this.childMultipleSelection)){
        this.$my_message(`存在打包类标签明细，不能删除！`, "warning");
        return
      }
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
      this.isScan = false;
      this.getProductRegistCertDetails(this.childForm.productId);
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        no: '',
        "productName": "",
        "specName": "",
        "manufacturerName": "",
        "locationName": "",
        "mainNo": "",
        "traceNo": "",
        supplierProductId: '',
        "productId": '',
        "specId": '',
        productRegistCertId: '',
        "productRegistCertNo": "",
        "onlineNo": "",
        "unit": "",
        "minUnit": "",
        "packSpec": "",
        "manufacturerId": '',
        "locationId": '',
        "manufactureDate": "",
        "batch": "",
        "validityDate": "",
        "serialNo": "",
        "number": 1,
        refundNumber: 0,
        "price": 0,
        "amount": 0,
        "remark": "",
      };
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm () {
      this.pushChildForm(true);
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();
      // this.resetDetailFormData();

      this.getProductList('')
    },
    pushChildForm (close) {
      let result = true
      this.$refs["childForm"].validate((valid) => {
        result = valid
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        if (this.childForm.mainNo && this.childForm.traceNo) {
          var childForm = this.childForm
          // 添加行
          let arr = this.form.details.filter(
            (item) => item.mainNo == childForm.mainNo && item.traceNo == childForm.traceNo
          );

          // 添加行记录
          if (arr.length > 0) {
            // 存在则把列表的数据拿过来，并且数量加1
            this.form.details = this.form.details.map((item) => {
              if (
                item.mainNo == childForm.mainNo &&
                item.traceNo == childForm.traceNo
              ) {
                item.packSpec = childForm.packSpec;
                item.locationId = childForm.locationId;
                item.locationName = childForm.locationName;
                item.manufactureDate = childForm.manufactureDate;
                item.batch = childForm.batch;
                item.validityDate = childForm.validityDate;
                item.serialNo = childForm.serialNo;
                item.remark = childForm.remark;
                item.number = childForm.number;
                // item.unUseNumber = childForm.unUseNumber
                item.price = childForm.price;
                item.amount = childForm.amount;
              }
              return item;
            });
          } else {
            // 不存在则添加行记录
            var childForm = JSON.parse(JSON.stringify(this.childForm))
            childForm.$index = this.form.details.length + 1
            this.form.details.push(childForm)
          }
        } else {
          if (this.editChildren) {
            let item = this.form.details.find(
              (e) => e.$index == this.childForm.$index
            );
            Object.assign(item, this.childForm);
          } else {
            let arr = this.findMatchingObject(this.childForm,this.acceptInStockDetails)
            if(arr){
              arr.number = this.childForm.number
              arr.price = this.childForm.price
              arr.amount = this.childForm.amount
              this.form.details.push(arr)
            }else{
              this.form.details.push(this.childForm)
            }
            
          }
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
          this.count = 0;
          this.isScan = false;
        }
      });
      return result
    },
    // 查询里面有没有一样的明细
    findMatchingObject(selectedObject, array) {        
        return array.find(item => {
            // 比较关键字段
            return (
                item.productName == selectedObject.productName &&
                item.specName == selectedObject.specName &&
                item.manufacturerName == selectedObject.manufacturerName &&
                item.supplierProductId == selectedObject.supplierProductId &&
                item.supplierProductNo == selectedObject.supplierProductNo &&
                item.productId == selectedObject.productId &&
                item.specId == selectedObject.specId &&
                item.productRegistCertId == selectedObject.productRegistCertId &&
                item.productRegistCertNo == selectedObject.productRegistCertNo &&
                item.manufacturerId == selectedObject.manufacturerId &&
                item.batch == selectedObject.batch &&
                item.price == selectedObject.price &&
                item.billingPrice == selectedObject.billingPrice &&
                item.serialNo == selectedObject.serialNo &&
                item.hasTagCode == selectedObject.hasTagCode
            );
        });
    },

    // childNumberChange () {
    //   // this.childForm.notReceivedNumber = this.childForm.number
    //   // this.childForm.planOrderNumber = this.childForm.number
    //   // this.childForm.actualOrderNumber = this.childForm.number
    //   this.autoAmount();
    // },
    autoAmount () {
      // this.childForm.billingPrice = this.childForm.price
      this.childForm.amount = (this.childForm.number * this.childForm.price).toFixed(4) * 1;
      // this.childForm.unBillAmount = this.childForm.amount;
    },
    autoTotalAmount () {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber.toFixed(3) * 1;
      this.form.totalAmount = totalAmount.toFixed(4) * 1;
      this.form.unBillNumber = totalNumber;
      this.form.unBillAmount = totalAmount;
    },

    // scan

    openScanner (ev) {
      if (!this.form.warehouseId || this.form.warehouseId == "") {
        this.$my_message("请先选择库房", 'warning');
        return;
      }
      this.count = 0;
      this.resetDetailFormData();
      this.isScan = true;
      this.openSubformModal = true;

      ev.target.blur();
    },

    // change event
    acceptInStockChange (val) {
        return new Promise((resolve, reject) => {
          GetAcceptInStockById({
              id: val
            })
              .then(res => {
                // let arr = this.acceptInStockList.filter((item) => item.id == val);
                this.form.acceptInStockId = val;
                this.form.acceptInStockNo = res.returnData.no;
                this.form.category = res.returnData.category;
                this.form.categoryName = res.returnData.categoryName;
                this.form.warehouseId = res.returnData.warehouseId;
                this.form.warehouseName = res.returnData.warehouseName;
                this.form.warehouseCategoryName = res.returnData.warehouseCategory;
                this.form.warehouseCategoryName = res.returnData.warehouseCategoryName;
                this.form.supplierId = res.returnData.supplierId;
                this.form.supplierName = res.returnData.supplierName;
                let arr = JSON.parse(JSON.stringify(res.returnData.details))
                // 存明细查标签码
                this.acceptInStockDetails = arr.map(item=>{
                  item.number = item.number - item.refundNumber
                  item.amount = item.number * item.price
                  return item
                })
                this.autoTotalAmount()
                resolve(res.returnData)
                this.getProductList('');
              })
        })
 

    },
    locationChange (row) {
      row.locationId = row.locationName
    },
    childLocationChange (val) {
      this.childForm.locationId = val
    },
    supplierChange (val) {
      this.form.supplierId = val;
      this.getProductList('')
      this.form.details = []
    },
    warehouseChange (val) {
      this.form.warehouseId = val

      this.getLocations(val)
      this.getProductList('');
    },
    productChange (row) {
      let id = this.childForm.id
      // let arr = this.STATIC_ApplySupplierProducts.filter((item) => item.id == row.id)
      this.childForm = Object.assign(this.childForm, row) // this.mapper.SupplierProduct2Form(this.childForm, arr[0])
      this.childForm.id = id
      this.childForm.stockId = row.id
      this.childForm.number = 1
      this.childForm.amount = this.childForm.price
      this.childForm.remark = ''

      // if (row.billingLogoName == '是') {
      //   this.childForm.price = 0
      // }
      this.$refs.number.focus();
      this.$refs.number.select();

      this.$refs.childForm.validateField('productName')
    },

    getProductList (keyWord) {

      // query.warehouseId = this.form.warehouseId
      // query.supplierId = this.form.supplierId
      // query.acceptId = this.form.acceptInStockId
      // query.category = 0

      let query = {
        keyWord: keyWord,
        warehouseId: this.form.warehouseId,
        supplierId: this.form.supplierId,
        acceptId: this.form.acceptInStockId,
        category: 0,
        hasTagCode:0
      };

      this.getStocks(query)
    },

    getAcceptInStockList (keyWord) {
      var query = {
        keyWord: keyWord,
        pageSize: 100,
        pageIndex: 1,
        isShowOtherStatus: 0,
        returnState: 0,
        stockCategory: 0,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId()
      }
      GetAcceptInStocks(query)
        .then((res) => {
          this.acceptInStockList = res.returnData.data;
        });
    },
    createPdaTask () {

      this.form.unShelfState = 0
      if(this.form.details.length > 0){
        this.$my_message("创建PDA任务明细必须为空", 'warning');
        return;
      }
      this.proTemSave()
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}

/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
